"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericIndexScene = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_router_redux_1 = require("react-router-redux");
const Card_1 = require("../../components/Card/Card");
const CardTitle_1 = require("../../components/CardTitle/CardTitle");
const DataTable_1 = require("../../components/DataTable/DataTable");
exports.GenericIndexScene = (props) => {
    const { createLink, title, tNamespace, columns, defaultSorted, query, redirectUrl, ExtraElement, onClick, loadingSelector, dataSelector, dataSizeSelector, onChangeLoopback, } = props;
    const isLoading = react_redux_1.useSelector(loadingSelector);
    const dataSize = react_redux_1.useSelector(dataSizeSelector);
    const data = react_redux_1.useSelector(dataSelector);
    const dispatch = react_redux_1.useDispatch();
    const { t } = react_i18next_1.useTranslation(tNamespace);
    let addLink = react_1.default.createElement("span", null);
    if (createLink) {
        addLink = (react_1.default.createElement(react_router_dom_1.Link, { className: "btn btn-primary float-right", to: createLink }, t('addNew')));
    }
    const onChange = react_1.useCallback((config) => {
        dispatch(onChangeLoopback(config));
    }, [onChangeLoopback, dispatch]);
    let handleClick = onClick;
    if (redirectUrl) {
        handleClick = react_1.useCallback((_, row) => {
            dispatch(react_router_redux_1.push(redirectUrl.replace(':id', `${row.id}`)));
        }, [redirectUrl, dispatch]);
    }
    return (react_1.default.createElement(Card_1.Card, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            addLink,
            react_1.default.createElement(CardTitle_1.CardTitle, { lg: true }, title || t('title')),
            ExtraElement ? react_1.default.createElement(ExtraElement, null) : '',
            react_1.default.createElement(DataTable_1.DataTable, { data: data, totalSize: dataSize, keyField: "id", onChangeLoopback: onChange, loading: isLoading, onClick: handleClick, columns: columns, defaultSorted: defaultSorted || { dataField: 'id', order: 'asc' }, query: query }))));
};
//# sourceMappingURL=GenericIndexScene.js.map